import type { MouseEventHandler } from 'react'
import { useContext, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import TextLink from 'LuxKit/TextLink'
import ModalContext from 'contexts/ModalContext'
import CarHireItemSummaryLocationModal from 'components/Common/OrderView/OrderItemSummaries/CarHireItemSummary/CarHireItemSummaryLocationModal'
import {
  DROP_OFF_LOCATION_TAB_ID,
  PICK_UP_LOCATION_TAB_ID,
  type CarHireLocationTabId,
} from 'components/CarHire/carHireLocationTabs'

interface Props {
  sameLocation: boolean
  pickUpLocationName: string
  dropOffLocationName: string
  order: App.Order
}

export default function CarHirePurchaseSummaryLocation(props: Props) {
  const { sameLocation, pickUpLocationName, dropOffLocationName, order } = props

  const showModal = useContext(ModalContext)

  const onLocationModalClick = useCallback<MouseEventHandler<HTMLAnchorElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()
    const openTab: CarHireLocationTabId = event.currentTarget.dataset.tab === DROP_OFF_LOCATION_TAB_ID
      ? DROP_OFF_LOCATION_TAB_ID
      : PICK_UP_LOCATION_TAB_ID
    showModal(<CarHireItemSummaryLocationModal orderItem={order.carHireItems[0]} openTab={openTab} />)
  }, [order.carHireItems, showModal])

  return (
    <>
      {sameLocation && <FormattedMessage
        id="8Mw2Yh-nXF1FjAJdWVZ-"
        defaultMessage="Pick-up & Drop-off at {locationLink}"
        description="Car hire pick-up and drop-off location when both are the same"
        values={{
          locationLink: <TextLink onClick={onLocationModalClick}>{pickUpLocationName}</TextLink>,
        }}
      />}
      {!sameLocation && <>
        <FormattedMessage
          id="SeFl0uW1Qbkw8sXCys0l"
          defaultMessage="Pick up at {locationLink}"
          description="Label displaying the car hire pick-up location with a link to the map details"
          values={{
            locationLink: <TextLink data-tab={PICK_UP_LOCATION_TAB_ID} onClick={onLocationModalClick}>{pickUpLocationName}</TextLink>,
          }}
        />
        <div>
          <FormattedMessage
            id="eouKgeib-ibPyenIqOR1"
            defaultMessage="Drop-off at {locationLink}"
            description="Label displaying the car hire drop-off location with a link to the map details"
            values={{
              locationLink: <TextLink data-tab={DROP_OFF_LOCATION_TAB_ID} onClick={onLocationModalClick}>{dropOffLocationName}</TextLink>,
            }}
          />
        </div>
      </>}
    </>
  )
}
